// extracted by mini-css-extract-plugin
module.exports = {"hero":"PostHero-module--hero--18AnP","caption":"PostHero-module--caption--2OlGe"};